import * as React from 'react';
import { SeriaPlus } from './SeriaPlus';
import { seriaPlusByLocation__DEPRECATED } from '../../settings/seriaPlusScheme';
import { useSelector } from 'react-redux';
import { getFilterLocation } from '../../selectors';

export const SeriaPlusContainer: React.FC = () => {
  const location = useSelector(getFilterLocation);

  return location in seriaPlusByLocation__DEPRECATED ? (
    <SeriaPlus scheme={seriaPlusByLocation__DEPRECATED[location]} />
  ) : null;
};
